export const constructMessage = (notificationData) => {
  const actorName =
    `${notificationData?.actor?.first_name || ''} ${notificationData?.actor?.last_name || ''}`.trim();
  const purpose = notificationData?.action_object?.purpose || notificationData?.action_object?.ticket_type_legacy || 'ticket';
  const verb = `${notificationData.verb}`;
  const recipientName =
    `${notificationData.recipient?.first_name || ''} ${notificationData.recipient?.last_name || ''}`.trim();
  const actor = actorName || 'System';

  const targetContentText = notificationData?.target_content_type;

  let message;

  // Format verbs to be more readable
  const formatVerb = (verb) => {
    return verb?.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  };

  // Format content type to be more readable
  const formatContentType = (contentType) => {
    if (!contentType) return '';
    return contentType?.split(' | ')?.[0]?.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  };

  if (verb === "initiated") {
    message = `${actor} submitted ${purpose} request.`;
  } else if (verb === "assigned") {
    message = `${actor} assigned the ${purpose} to you.`;
  } else if (verb === "requested") {
    message = `${actor} requested ${purpose}.`;
  } else if (verb === "resubmitted") {
    message = `${actor} resubmitted the ${purpose} request.`;
  } else if (verb === "forwarded_to_admin") {
    message = `${actor} forwarded the ${purpose} request to admin.`;
  } else if (verb === "approved") {
    message = `${actor} approved your ${purpose} request.`;
  } else if (verb === "rejected") {
    message = `${actor} rejected your ${purpose} request.`;
  } else if (verb === "closed") {
    message = `${actor} closed the ${purpose} request.`;
  } else if (verb === "forwarded_to_curator") {
    message = `${actor} forwarded the ${purpose} request to curator.`;
  } else if (verb === "completed") {
    message = `The ${purpose} request has been completed.`;
  } else if (verb === "returned") {
    message = `${actor} returned the ${purpose} request.`;
  } else if (verb === "awaiting_payment") {
    message = `Payment is pending for ${purpose}.`;
  } else if (verb === "failed") {
    message = `Payment failed for ${purpose}.`;
  } else if (verb === "cancelled") {
    message = `${actor} cancelled the ${purpose} request.`;
  } else if (verb === "in_progress") {
    message = `The ${purpose} request is in progress.`;
  } else if (verb === "refund_requested") {
    message = `${actor} requested a refund for ${purpose}.`;
  } else if (verb === "refunded") {
    message = `${actor} processed refund for ${purpose}.`;
  } else {
    // Default case with better formatting
    const formattedVerb = formatVerb(verb);
    const formattedType = formatContentType(targetContentText);
    message = `${actor} ${formattedVerb} ${formattedType || 'task'}.`;
  }

  return message;
};
